import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import {
  RadioGroup,
  RadioGroupPropsT,
} from '@consumer-frontend/shared-ui';

import { NcRadioButton, NcRadioButtonPropsT } from '../NcRadioButton';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/form/radio-button.scss';

export type NcRadioGroupT = React.FC<RadioGroupPropsT<NcRadioButtonPropsT>>;

export const NcRadioGroup: NcRadioGroupT = ({
  children,
  className,
  RadioButtonComponent = NcRadioButton,
  options,
  ...groupProps
}) => {
  const classNames = mergeClassNameStrings('nc-radio-group', className);

  return (
    <RadioGroup
      className={classNames}
      groupError={groupProps.groupError}
      errorMessage={groupProps.errorMessage}
      RadioButtonComponent={RadioButtonComponent}
      {...groupProps}
    >
      {children || options?.map((buttonProps) => (
        <RadioButtonComponent
          {...buttonProps}
          checked={buttonProps.value === groupProps.value}
          errorMessage={groupProps.errorMessage}
          groupError
          id={`${groupProps.controlId}-${buttonProps.value}`}
          key={buttonProps.value}
          label={buttonProps.label}
          name={groupProps.controlId}
          onChange={groupProps.onChange}
          unavailable={buttonProps.unavailable}
          value={buttonProps.value}
        />
      ))}
    </RadioGroup>
  );
};
